import React from 'react';

import type { ContentBlock, ConversationCallbacks } from '../types';
import { TextBlockComponent } from './TextBlock';
import { CitationBlock } from './CitationBlock';

interface BlockRendererProps {
  block: ContentBlock;
  isStreaming?: boolean;
  onCitationClick?: ConversationCallbacks['onCitationClick'];
}

export const BlockRenderer = ({ block, isStreaming, onCitationClick }: BlockRendererProps) => {
  if (block.type === 'text') {
    return (
      <>
        <TextBlockComponent block={block} isStreaming={isStreaming} />
        {block.citations && block.citations.length > 0 && (
          <CitationBlock citations={block.citations} onCitationClick={onCitationClick} />
        )}
      </>
    );
  }

  return null;
};

export { TextBlockComponent } from './TextBlock';
export { CitationBlock } from './CitationBlock';
